import { useEffect, useState } from "react";
import { usePageNameContext } from "../../contexts/PageTitleContext";

import LoadingWheel from "../../components/shared/LoadingWheel";
import { PlusSmallIcon } from "@heroicons/react/24/outline";
import { IWarehouseLocation } from "../../models/Location";
import useWarehouseLocations from "../../data/useWarehouseLocations";
import WarehouseLocationsTable from "../../components/warehouseLocations/WarehouseLocationsTable";
import WarehouseLocationsModal from "../../components/warehouseLocations/WarehouseLocationsModal";
import { ButtonInput } from "../../components/shared/Inputs/ButtonInput";

export default function WarehouseLocations() {
  const { setInfo } = usePageNameContext();
  const { warehouseLocations: allLocations } = useWarehouseLocations();
  const [locations, setLocations] = useState<IWarehouseLocation[] | undefined>(undefined);
  const [location, setLocation] = useState<IWarehouseLocation | undefined>(undefined);
  const [editLocation, setEditLocation] = useState<IWarehouseLocation | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [createOpen, setCreateOpen] = useState(false);
  const [showInactive, setShowInactive] = useState(false);

  useEffect(() => {
    setInfo({
      name: "Warehouse Locations",
      desc: "View and manage warehouse shelving locations",
    });
  }, []);

  useEffect(() => {
    if (!allLocations.isLoading && allLocations.data) {
      const normalizedSearchTerm = searchTerm?.trim()?.toLowerCase();
      const filteredLocations = allLocations.data?.data?.filter((warehouseLocation) =>
        warehouseLocation.displayName?.toLowerCase()?.includes(normalizedSearchTerm)
      );

      setLocations(filteredLocations);
      setIsLoading(false);
    }
  }, [allLocations.isLoading, allLocations.data, searchTerm]);

  const handleSetLocation = (location: IWarehouseLocation) => {
    setEditLocation(location);
    setCreateOpen(true);
  };

  const handleAddLocation = () => {
    setEditLocation(undefined);
    setCreateOpen(true);
  }

  return allLocations.isLoading || isLoading ? (
    <div className="mt-8 min-h-[50vh] my-4 p-4 bg-white rounded-lg shadow">
      <LoadingWheel />
    </div>
  ) : (
    <>
      <WarehouseLocationsModal open={createOpen} setOpen={setCreateOpen} location={editLocation} />
      <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div className="w-full sm:max-w-sm">
          <label htmlFor="warehouse-location-search" className="block text-sm font-medium text-gray-700">
            Search locations
          </label>
          <input
            id="warehouse-location-search"
            type="text"
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            placeholder="Search by location name"
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
          />
        </div>

        {/* Button for adding a new location */}
        <ButtonInput isSubmit={false} onClick={() => handleAddLocation()} classes={undefined} >
          <div className="flex items-center">
            <PlusSmallIcon className="h-5 w-5 mr-2" />
            Add New Location
          </div>
        </ButtonInput>

      </div>

      {/* Table of warehouse locations */}
      <WarehouseLocationsTable locations={locations!} setLocation={handleSetLocation} />
      {/* <LocationsTable locations={locations!} setLocation={handleSetLocation} /> */}
    </>
  );
}
